"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatalogBasketModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Modal_1 = require("../../../components/Modal");
var react_1 = require("react");
require("./style.scss");
var CatalogBasketModal = function (_a) {
    var children = _a.children, showBasket = _a.showBasket, setShowBasket = _a.setShowBasket, basketItemLength = _a.basketItemLength;
    (0, react_1.useEffect)(function () {
        if (basketItemLength === 0) {
            setShowBasket(false);
        }
    }, [basketItemLength]);
    return ((0, jsx_runtime_1.jsx)(Modal_1.Modal, __assign({ className: 'basket-modal-mobile', propsStyles: {
            overlay: {
                zIndex: 20,
            },
        }, closeModal: function () { return setShowBasket(false); }, isOpen: showBasket }, { children: children })));
};
exports.CatalogBasketModal = CatalogBasketModal;
